import { Outlet } from 'react-router-dom'
import { QueueIndicator } from './QueueIndicator'
import { TabBar } from './TabBar'

/**
 * Оболочка водительского приложения.
 *
 * Только мобильная раскладка: ни Sidebar, ни TopBar, ни командной палитры
 * здесь нет — они не импортируются и не попадают в бандл.
 */
export function DriverLayout() {
  return (
    <div className="driver-shell">
      <QueueIndicator />
      <main className="driver-content">
        <Outlet />
      </main>
      <TabBar />
    </div>
  )
}
